export enum CompanyType {
  OWNER = 'OWNER',

  MANUFACTURER = 'MANUFACTURER',

  TRANSPORTER = 'TRANSPORTER',

  REPRESENTATIVE = 'REPRESENTATIVE',
}
